export const BudgetFieldTotalDefault = 2000000;
export const BudgetFieldMonthlyDefault = 20000;
export const BudgetFieldTotalDefault = 2000000;
export const BudgetFieldMonthlyDefault = 20000;
